import React from 'react';
import { Mail, CheckCircle, ShoppingCart } from 'lucide-react';


const CRMWidget = ({ data, loading }) => {
  // Safe default
  const crm = data || {
    total_recipients: 0,
    recipients_read: 0,
    orders: 0,
    gmv: 0,
    plans: []
  };

  const formatCurrency = (num) => {
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 2,
      minimumFractionDigits: 2
    }).format(num || 0);
  };

  return (
    <div className={`dashboard-card crm-widget ${loading ? 'shimmer skeleton' : ''}`}>
      <div className="metrics-header">
        <div className="metrics-title">
          <Mail size={20} color="#f43f5e" /> CRM
        </div>
        <div 
          className="status-badge" 
          style={{
            backgroundColor: (!crm.plans || crm.plans.length === 0) ? 'rgba(239, 68, 68, 0.1)' : 'rgba(16, 185, 129, 0.1)', 
            color: (!crm.plans || crm.plans.length === 0) ? '#ef4444' : '#10b981', 
            border: `1px solid ${(!crm.plans || crm.plans.length === 0) ? 'rgba(239, 68, 68, 0.2)' : 'rgba(16, 185, 129, 0.2)'}`
          }}
        >
            {(!crm.plans || crm.plans.length === 0) ? 'Inactive' : 'Active'}
        </div>
      </div>

      {/* Top Grid: 4 Metrics */}
      <div className="crm-metrics-grid">
        <div className="crm-metric-box">
             <div className="crm-label">CRM GMV</div>
             <div className="crm-value">{formatCurrency(crm.gmv)}</div>
        </div>
        <div className="crm-metric-box">
             <div className="crm-label">CRM orders</div>
             <div className="crm-value">{crm.orders}</div>
        </div>
        <div className="crm-metric-box">
             <div className="crm-label">Recipients</div>
             <div className="crm-value">{(crm.total_recipients || 0).toLocaleString()}</div>
        </div>
        <div className="crm-metric-box">
             <div className="crm-label">Recipients Read</div>
             <div className="crm-value">{(crm.recipients_read || 0).toLocaleString()}</div>
        </div>
      </div>

      {/* Plans List */}
      <div className="crm-plans-list">
        <div className="crm-list-header">
            <span>Plan Name</span>
            <span>GMV Generated</span>
        </div>
        
        <div className="crm-list-body">
            {(crm.plans || []).map((plan, idx) => (
                <div key={idx} className="crm-plan-row">
                    <div className="plan-name">{plan.name}</div>
                    <div className="plan-gmv">{formatCurrency(plan.gmv)}</div>
                </div>
            ))}
            {(!crm.plans || crm.plans.length === 0) && (
                <div className="crm-plan-row" style={{justifyContent:'center', color:'#666', fontStyle:'italic'}}>
                    No active plans
                </div>
            )}
        </div>
      </div>
    </div>
  );
};

export default CRMWidget;
